/**
 * Anchor Scroll Correction
 *
 * Ensures correct hash-based scrolling after page load when dynamic layout changes (e.g. sliders, transforms) cause incorrect anchor positioning.
 */

(function (window) {
  function waitForPageToSettle() {
    return new Promise((resolve) => {
      requestAnimationFrame(() => resolve());
    });
  }

  function forceFinalAnchorScroll() {
    if (!location.hash) return;

    var target = document.querySelector(location.hash);
    if (!target) return;

    requestAnimationFrame(() => {
      target.scrollIntoView({
        block: 'start',
        behavior: 'auto',
      });
    });
  }

  window.addEventListener('load', async function () {
    await waitForPageToSettle();
    forceFinalAnchorScroll();
  });
})(this);
